<template>
  <div>
    <h2>
      Debug
    </h2>
    <div>
      Questa pagina è riservata allo sviluppo, usa questa pagina solo SE SAI*OSA STAI FACENDO.
    </div>
    <div class="mt-3">
      Manda messaggio a MyFigb
      <b-button-group>
        <b-input v-model="messageToMyFigb"></b-input>
        <b-button @click="sendMessageToMyFigb" variant="primary">Invia</b-button>
      </b-button-group>
    </div>
    <div class="mt-3">
      Test Webcam
      <b-button @click="openWebcamTest" variant="primary">Apri Test Webcam</b-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Debug',
  data() {
    return {
      messageToMyFigb: "REG#posizione al tavolo non corretta, necessario ripristino della connessione eseguendo nuovamente la registrazione",
      initialized_model: null,
      rawRecognizedCards: []
    };
  },
  methods: {
    sendMessageToMyFigb() {
      window.parent.postMessage(this.messageToMyFigb, '*');
    },
    openWebcamTest() {
      window.location = 'https://risultaticonvivium.altervista.org/webcamTest.html';
    }
  }
};
</script>

<style scoped>
</style>
